
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from "axios"
//MUI
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Rating from '@material-ui/lab/Rating'
//Icons
import BookmarkIcon from '@material-ui/icons/Bookmark'
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder'
//Components
import * as globalFuncs from '../../../globalFuncs/Entities/Product/Index'
import * as TokenBaseFunc from "../../../globalFuncs/TokenBaseActions"
import LoginModal from "../../LoginModal/Index"

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: '#28A504',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: "#417557",
        },
    },
    btnAddBookmark: {
        minWidth: '35px',
        backgroundColor: "transparent",
        boxShadow: 'none !important',
        border: 'none',
        padding: '0px !important',
        '&:hover': {
            backgroundColor: "transparent",
        },
        '&:focus': {
            backgroundColor: "transparent",
        },
    }
}));

const ProductBox = ({ product, lang }) => {

    const classes = useStyles();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [bookmarked, setBookmarked] = React.useState(false)
    const [sending, setSending] = React.useState(false)

    useEffect(() => {
        if (typeof product.bookmarked === "boolean") {
            // console.log(product.title)
            // console.log(product.bookmarked)
            if (product.bookmarked) {
                setBookmarked(true)
                setSending(true)
            }
        }
        // console.log(product.bookmarked)
    }, [])

    const openModal = () => {
        setIsModalOpen(true);
    }

    const onClose = () => {
        setIsModalOpen(false);
    }

    const handleAddBookmark = async (bid) => {
        if (TokenBaseFunc.TokenStatus()) {
            try {
                setSending(true)
                var formData = new FormData()
                formData.append('ProductId', bid)
                const { data } = await axios.post("/api/products/bookmarks/add", formData, {
                    headers: {
                        Authorization: `Bearer ` + TokenBaseFunc.ReturnToken(),
                        'content-type': 'multipart/form-data'
                    }
                })
                if (data.status === "ok") {
                    setBookmarked(true)
                    setSending(false)
                }
            }
            catch (error) {
                console.log("error:")
                console.log(error)
            }
        }
        else {
            openModal()
        }
    }

    return (
        <>
            <div dir="rtl" className="product">

                <div className="image">
                    <Link to={`/product/${product.id}`}>
                        <img alt="" src={product.imgURL} />
                    </Link>
                </div>
                <div className="content">

                    <Link to={`/product/${product.id}`}>
                        <h3>{product.title}</h3>
                    </Link>

                    {(product.outOfStock) ? (
                        <p style={{ textAlign: "center", marginTop: '0px', marginBottom: '10px' }}>
                            <span className="outOfStockBadge" style={{ margin: '0px auto 0px auto' }}>{lang === "ar" ? "غير متوفره" : "ناموجود"}</span>
                        </p>
                    ) : (
                        <p className="price">{globalFuncs.SepratePrice(product.price250, lang)}</p>
                    )}

                    <div style={{ textAlign: 'center' }}>
                        <Rating
                            name="simple-controlled2"
                            value={product.starRating}
                            disabled
                        />
                    </div>

                    <div className="productBoxBottomArea">
                        <div className="IconArea">
                            <BookmarkIcon style={{ display: (bookmarked) ? 'inline-block' : 'none' }} />
                            <Button style={{ display: (bookmarked) ? 'none' : 'inline-block' }} className={classes.btnAddBookmark} disabled={sending} onClick={() => { handleAddBookmark(`${product.id}`) }}><BookmarkBorderIcon /></Button>
                        </div>
                        <div className="btnArea">
                            <Link to={`/product/${product.id}`}>
                                <Button variant="contained" color="primary" className={classes.btn + ' sbBtn'}>
                                    {lang === "ar" ? "تفاصيل المنتج" : "جزئیات محصول"}
                                </Button>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
            <LoginModal open={isModalOpen} onClose={onClose} redirect={true} />
        </>
    )
}

export default ProductBox
